export const siteInfo = {
  '02': {
    name: 'Haleakala',
    ATLAScode: 'HKO',
    MPCcode: 'T05',
    timezone: 'US/Hawaii',
    coordinates: '-156.2570°E 20.7076°N'
  },
  '01': {
    name: 'Maunaloa',
    ATLAScode: 'MLO',
    MPCcode: 'T08',
    timezone: 'US/Hawaii',
    coordinates: '-155.5761°E 19.5361°N'
  },
  '04': {
    name: 'El Sauce',
    ATLAScode: 'CHL',
    MPCcode: 'W68',
    timezone: 'Chile/Continental',
    coordinates: '70.76498°W 30.47103°S'
  },
  '03': {
    name: 'Sutherland',
    ATLAScode: 'STH',
    MPCcode: 'M22',
    timezone: 'Africa/Johannesburg',
    coordinates: '20.8105°E 32.3783°S'
  }
};
